import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function KeyContainer({ children, ...props }: FlexProps) {
  return (
    <Flex
      bg="brand.background.light"
      borderRadius="smaller"
      boxShadow="card"
      gap="big"
      py={{ base: "smallest", lg: "smaller" }}
      px={{ base: "smaller", lg: "small" }}
      {...props}
    >
      {children}
    </Flex>
  );
}
